module.exports = __webpack_public_path__ + "static/media/projectShow.123884ea.jpg";